import React, { useEffect, useState } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import EAMultipleChoiceChipSelector from "../../shared/ChoiceChip/EAMultipleChoiceChipSelector";
import useFacility from "../../../../utils/hooks/useFacility";
import { get } from "../../../api";
import { AssortGroup } from "../../../models/AssortGroup";
import { GET_ASSORTGROUP } from "../../../api/apiRoutes";
import getId from "../../../../utils/getId";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
}

const GdanskMaterialGroupInput: React.FC<IProps> = ({ form, setForm }) => {
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  const getAssortGroups = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_ASSORTGROUP(facilityIds));
    if (!isError) {
      const newResult = result.map((item: AssortGroup) => ({ value: getId(item), label: item.name }));
      setOptions(newResult);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAssortGroups();
    //eslint-disable-next-line
  }, []);

  return (
    <div className="gdansk-input-content">
      <h5 className="no-line-height">Wybierz porę dnia</h5>
      <EAMultipleChoiceChipSelector
        options={options ?? []}
        selectedValue={form.materialGroupIds}
        onSelect={(value, label) => setForm({ ...form, materialGroupIds: value, materialGroupName: label })}
        chipSize="small"
        loading={loading}
        width="70%"
      />
    </div>
  );
};

export default GdanskMaterialGroupInput;
